import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {DynamicIdService} from 'shared/_services/dynamic.id.service';
import {ControlTemplate} from '../_interface/control-template.enum';

@Component({
	selector: 'form-switch',
	templateUrl: './switch.component.html',
	styleUrls: ['./switch.component.scss']
})
export class SwitchComponent implements OnInit {
	@Input() control: UntypedFormControl;
	@Input() id: string = this.dynamicIdService.getId('text-input');
	@Input() label: string;
	@Input() template: ControlTemplate = ControlTemplate.inline;
	@Input() switchPosition: 'left' | 'right' = 'left';
	@Input() widthAuto = true;
	@Input() labelClass = '';

	ControlTemplate = ControlTemplate;
	value = false;

	get labelClasses(): Record<string, boolean> {
		const classes: Record<string, boolean> = {
			'switch-left': this.switchPosition === 'left',
			'switch-right': this.switchPosition === 'right',
			'full-width': !this.widthAuto,
		};
		if (this.labelClass) {
			classes[this.labelClass] = true;
		}
		return classes;
	}

	constructor(private dynamicIdService: DynamicIdService) { }

	ngOnInit(): void {
		if (!this.control) throw new Error('Control is required');
		if (this.control.value) {
			this.value = this.control.value;
		}
	}
}
